import * as React from 'react';
import Downshift from 'downshift';
import * as classNames from 'classnames';
import { inputContent } from '../../../content/content';
import { DataTest } from '../../../utilities/testAutomation';

interface DropdownInputProps extends DataTest {
  options: string[];
  label?: string;
  onChange: (e: any) => void;
  name: string;
}

export const DropdownInput = ({
  options,
  label,
  onChange,
  name,
  dataTest,
}: DropdownInputProps) => (
  <div className="input-wrapper">
    <div className="dropdown">
      <Downshift
        onChange={(value: string) => { onChange({ target: { name, value } }); }}
        render={({
          getButtonProps,
          getItemProps,
          selectedItem,
          highlightedIndex,
          isOpen,
        }) => (
          <div className="options-wrapper">
            <button
              {...getButtonProps({
                className: classNames('selector', { open: isOpen }),
                'aria-label': isOpen ? 'close.menu' : 'open.menu',
              })}
              {...dataTest}
            >
              <span className="select-text">{selectedItem || label || inputContent.dropdownInputPlaceholder}</span>
              <span className="select-arrow-zone" />
            </button>
            {isOpen ? (
              <div className="options">
                {options.map((item, index) => (
                  <button
                    className={classNames('option', { focused: highlightedIndex === index })}
                    {...getItemProps({
                      key: item,
                      index,
                      item,
                      name,
                      value: item,
                    })}
                  >
                    {item}
                  </button>
                ))}
              </div>
            ) : null}
          </div>
        )}
      />
    </div>
  </div>
);

export default DropdownInput;



// WEBPACK FOOTER //
// ./src/components/Inputs/DropdownInput/DropdownInput.tsx